// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"K_wJ h_jp h_fp h_fs h_fD h_dL h_t","menuItemSub":"K_wK h_dS h_fp h_fD","menuMainLink":"K_wL h_jq h_hk","menuLink":"K_wM h_jq h_hk","Link":"K_tC z_tC z_s0 z_tk"};